'use strict';

var _ = require('lodash');
var SimpleGridColumnUtilsService = function SimpleGridColumnUtilsService() {
  function updateStyling(column) {
    column.style = '';
    if (column.minWidth) {
      column.style = column.style + 'min-width:' + column.minWidth + ';';
    }
    if (column.width) {
      column.style = column.style + 'width:' + column.width + ';';
    }
    return column;
  }
  function updateRowspan(column, maxNesting) {
    column.rowspan = !column.columns ? maxNesting - column.nestingLevel : 1;
  }
  function updateColspan(column, nestingLevel, acumulator) {
    acumulator.push(column);
    column.nestingLevel = nestingLevel;
    if (_.isNil(column.colspan)) {
      column.colspan = 0;
    }
    if (_.isNil(column.columns)) {
      column.colspan = 1;
      return column.colspan;
    } else {
      column.columns.forEach(function (nestedColumn) {
        column.colspan += updateColspan(nestedColumn, nestingLevel + 1, acumulator);
      });
    }
    return column.colspan;
  }
  function createDisplayModel(columns) {
    var tmpModel = _.chain(columns).cloneDeep().reduce(function (result, column) {
      updateColspan(column, 0, result);
      return result;
    }, []).map(updateStyling).reduce(function (result, column) {
      result.columns.push(column);
      result.maxNesting = result.maxNesting < column.nestingLevel ? column.nestingLevel : result.maxNesting;
      return result;
    }, {
      columns: [],
      maxNesting: 0
    }).value();
    var maxNestingLevel = tmpModel.maxNesting + 1;
    var headerColumns = _.chain(tmpModel.columns).forEach(function (column) {
      updateRowspan(column, maxNestingLevel);
    }).groupBy('nestingLevel').value();
    var dataFields = _.chain(tmpModel.columns).filter('field').map(function (item) {
      return _.pick(item, ['field', 'type', 'format', 'renderer', 'tooltipPlacement']);
    }).value();
    return {
      headerColumns: headerColumns,
      dataFields: dataFields,
      maxNesting: maxNestingLevel
    };
  }
  return {
    createDisplayModel: createDisplayModel
  };
};
SimpleGridColumnUtilsService.$inject = [];
module.exports = SimpleGridColumnUtilsService;